import React from "react";
import { Box, Typography, Button } from "@material-ui/core";

/**
 * Guards the heavyweight CommonDigitizedDocument viewer so a runtime error
 * (e.g. missing batch/access-control context in the demo) degrades gracefully
 * instead of white-screening the Document Repository.
 */
class DigitizedErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("CommonDigitizedDocument failed to render:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box style={{ padding: 40, textAlign: "center" }}>
          <Typography style={{ fontWeight: 600, marginBottom: 8 }}>
            Digitized fields view is not available for this document.
          </Typography>
          <Typography style={{ color: "#888", fontSize: "0.85rem", marginBottom: 20 }}>
            The extracted fields could not be loaded in this environment.
          </Typography>
          {this.props.onClose && (
            <Button
              variant="contained"
              onClick={this.props.onClose}
              style={{ textTransform: "none", backgroundColor: "#EB5E28", color: "#fff", borderRadius: "2rem" }}
            >
              Close
            </Button>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default DigitizedErrorBoundary;
